import React, { FC } from 'react';
import { navigate } from 'gatsby';
import Button from 'common/Button';
import ArticleTeaser from '../ArticleTeaser';
import { ArticleListProps } from './models';
import './ArticleList.scss';

const ArticleList: FC<ArticleListProps> = ({
  articleListSettings: {
    sectionTitle,
    numberOfArticles,
    isLabelsActive,
    moreText,
    loadAllArticlesButtonText,
    moreAriaLabel,
  },
  umbracoArticlesNodes,
  loadAllArticlesLink,
  showAllArticles = false,
}) => {
  const articleList = showAllArticles
    ? umbracoArticlesNodes
    : umbracoArticlesNodes.slice(0, numberOfArticles || 3);

  return (
    <section data-testid="article list" className="article-list">
      {!showAllArticles ? <h2 className="article-list__title">{sectionTitle}</h2> : null}
      <div className="article-list__row">
        {articleList.map((node) => (
          <ArticleTeaser
            key={node.title}
            {...{
              ...node,
              articleBannerImage: node.articleThumbnailImage,
              articleImageAlt: node.articleBannerImageAltText,
              isLabelsActive,
              moreText,
              moreAriaLabel,
            }}
          />
        ))}
      </div>
      {!showAllArticles && umbracoArticlesNodes.length > (numberOfArticles || 3) ? (
        <Button
          className="article-list__load-all-button d-flex"
          ariaLabel={loadAllArticlesButtonText}
          onClick={() => navigate(loadAllArticlesLink!)}
        >
          {loadAllArticlesButtonText}
        </Button>
      ) : null}
    </section>
  );
};

export default ArticleList;
